/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
// import { toast } from "sonner"
import apiService from "@/services/apiService"
import useErrorStore from "@/store/confirmationStore"
import { useAppStore } from "@/store/appStore"

export function LoginForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const showError = useErrorStore((s) => s.showError);
  const [phone, setPhone] = useState("")
  const [password, setPassword] = useState("")
  const [loginText, setLoginText] = useState("Login");
  const navigate = useNavigate();
  const handleSubmitLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setLoginText("Logging In...")
    event.preventDefault();
    if (!phone || !password) {
      showError("Please enter both email and password.");
      setLoginText("Login");
      return;
    }
    try {
      const response:any = await apiService.post('users/login',JSON.stringify({ phone, password }));
      console.log(response);
      if (!response) {
        throw new Error('Network response was not ok');
      }
      console.log('Login successful:', response.data);
      sessionStorage.setItem("userInfo", JSON.stringify(response.data));
      setLoginText("Logged In");
      useAppStore.getState().loadInitialData();
      navigate('/');
    } catch (error:any) {
      console.error('There was a problem with the login request:', error);
      showError(error);
      setPhone("");
      setPassword("");
      setLoginText("Login");
    }
  }
  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card>
        <CardHeader>
          <CardTitle>Login to your account</CardTitle>
          <CardDescription>
            Enter your email below to login to your account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form>
            <div className="flex flex-col gap-6">
              <div className="grid gap-3">
                <Label htmlFor="phone">Phone</Label>
                <Input
                  id="phone"
                  type="phone"
                  placeholder="9999999999"
                  autoComplete="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="grid gap-3">
                <div className="flex items-center">
                  <Label htmlFor="password">Password</Label>
                  <p className="ml-auto inline-block text-sm underline-offset-4 hover:underline">Forgot your password?</p>
                </div>
                <Input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required />
              </div>
              <div className="flex flex-col gap-3">
                <Button type="submit" className="w-full cursor-pointer bg-gradient-to-r from-[#0d2846] to-[#0d2846]/90 hover:from-[#0d2846]/90 hover:to-[#0d2846]" onClick={handleSubmitLogin}>
                  {loginText}
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}